import React from "react";
import { Link } from "react-router-dom";
import AppNavbar from "../components/AppNavbar";

const NotFoundPage = () => {
  return (
    <>
      <AppNavbar />

      <div
        style={{
          paddingTop: "120px",
          textAlign: "center",
          minHeight: "100vh",
          background: "#F5FAF9",
        }}
      >
        <h1 style={{ fontSize: "90px", color: "#2D8A7A" }}>404</h1>
        <h3 className="fw-bold mb-3">Sayfa Bulunamadı</h3>
        <p className="text-muted mb-4">
          Aradığınız sayfa mevcut değil veya taşınmış olabilir.
        </p>

        <Link to="/" className="btn btn-primary rounded-pill px-4">
          Ana Sayfaya Dön
        </Link>
      </div>
    </>
  );
};

export default NotFoundPage;
